import { auth } from '../data-types/initialisation/initialisationConstants';
import { SEARCH_TYPE } from '../data-types/search/searchEnums';
import { SEARCH_PARAM_KEY } from '../data-types/url/urlEnums';
import { handleJoinByCountry } from '../international/internationalUtils';
import { PATHS } from '../routing-system/appPaths';
import browserHistory from '../routing-system/browserHistory';
import { setCasinoFirstFlag } from '../state/actions/customizationActions';
import { setSearchText, setSearchType } from '../state/actions/navigationActions';
import { setCurrentSignUpPath } from '../state/actions/signupActions';
import { setAuthentication } from '../state/actions/userDataActions';
import { store } from '../state/store';
import {
  getSourceIdByName,
  handleAffIdUsage,
  handleAIdUsage,
  handleBannerIdUsage,
  handleSiteIdUsage,
  handleSourceIdUsage,
  handleUserBTagUsage,
  setupIdsSeparatelyFromBTag,
} from './incomeAccess';

export const clearSearchData = () => {
  const { navigation } = store.getState();
  const { search } = navigation;
  const { searchTerm, searchType } = search;

  if (searchType) {
    setSearchType(undefined);
  }

  if (searchTerm) {
    setSearchText('');
  }

  removeSearchParam(SEARCH_PARAM_KEY.SEARCH_TERM);
};

export const addSearchParamToURL = (key: SEARCH_PARAM_KEY, value: string) => {
  const path = window.location.pathname;
  const search = window.location.search;

  if (search && search.includes(`${key}=`)) {
    return;
  }

  if (search) {
    browserHistory.push({
      pathname: path,
      search: `${search}&${new URLSearchParams({ [key]: value }).toString()}`,
    });
  } else {
    browserHistory.push({
      pathname: path.endsWith('/') ? path : `${path}/`,
      search: `?${new URLSearchParams({ [key]: value }).toString()}`,
    });
  }
};

export const changeSearchParamValue = (key: SEARCH_PARAM_KEY, value: string) => {
  const path = window.location.pathname;
  const search = new URLSearchParams(window.location.search);

  if (search.has(key)) {
    search.set(key, value);
    browserHistory.replace({
      pathname: path,
      search: search.toString(),
    });
  }
};

export const removeSearchParam = (key: SEARCH_PARAM_KEY) => {
  const path = window.location.pathname;
  const search = new URLSearchParams(window.location.search);

  if (search.has(key)) {
    search.delete(key);
    browserHistory.replace({
      pathname: path,
      search: search.toString(),
    });
  }
};
export const getSearchParamValue = (key: SEARCH_PARAM_KEY, customSearch?: string) => {
  const search = new URLSearchParams(customSearch || window.location.search);

  return search.get(key) || undefined;
};

export const tryToSetAffiliateRelatedCookies = (searchParams: URLSearchParams, pathname: string, authentication: number) => {
  const paramsBTag = searchParams.get(SEARCH_PARAM_KEY.BTAG) || undefined;
  const paramsAffId = searchParams.get(SEARCH_PARAM_KEY.AFF_ID) || undefined;
  let paramsSourceId = searchParams.get(SEARCH_PARAM_KEY.SOURCE_ID) || undefined;
  if (!paramsSourceId) {
    const paramsSourceLabel = searchParams.get(SEARCH_PARAM_KEY.SOURCE) || undefined;
    paramsSourceId = (getSourceIdByName(paramsSourceLabel || '') as string) || undefined;
  }

  const subparamsBTagAId = searchParams.get(SEARCH_PARAM_KEY.A_ID) || undefined;
  const subparamsBTagBannerId = searchParams.get(SEARCH_PARAM_KEY.BANNER_ID) || undefined;
  const subparamsBTagSiteId = searchParams.get(SEARCH_PARAM_KEY.SITE_ID) || undefined;

  if (paramsBTag) {
    handleUserBTagUsage(paramsBTag);

    if (pathname === PATHS.SIGNUP.ROOT && authentication !== auth.AUTHENTICATED) {
      setAuthentication(auth.SIGNUP);
      setCurrentSignUpPath(PATHS.SIGNUP.STEPS.EMAIL);
    }
  }

  if (paramsAffId) {
    handleAffIdUsage(paramsAffId);
  }

  if (paramsSourceId) {
    handleSourceIdUsage(paramsSourceId);
  }

  if (subparamsBTagAId) {
    handleAIdUsage(subparamsBTagAId);
  }

  if (subparamsBTagBannerId) {
    handleBannerIdUsage(subparamsBTagBannerId);
  }

  if (subparamsBTagSiteId) {
    handleSiteIdUsage(subparamsBTagSiteId);
  }

  if (paramsBTag && !subparamsBTagAId && !subparamsBTagBannerId && !subparamsBTagSiteId) {
    setupIdsSeparatelyFromBTag(paramsBTag);
  }
};

export const checkIfUserComesFromCasinoAffiliation = (searchParams: URLSearchParams) => {
  const paramsCasinoFirst = searchParams.get(SEARCH_PARAM_KEY.CASINO_FIRST) || undefined;

  if (paramsCasinoFirst === 'true') {
    setCasinoFirstFlag(true);
  }
};

export const checkIfShouldDisplaySignUp = (searchParams: URLSearchParams) => {
  const signup = searchParams.get(SEARCH_PARAM_KEY.SIGNUP) || undefined;

  if (signup === 'true') {
    handleJoinByCountry();
  }
};

export const checkIfInSearchMode = (searchParams: URLSearchParams, customPath?: string) => {
  const path = customPath || window.location.pathname;
  const isOnSportsBook = path.startsWith(PATHS.APP.SPORTS.SPORTS_ROOT) || path.startsWith(PATHS.APP.SPORTS.EVENT_ROOT);
  const isOnCasino = path.startsWith(PATHS.APP.CASINO.ROOT);
  const searchTerm = searchParams.get(SEARCH_PARAM_KEY.SEARCH_TERM) || undefined;

  if (searchTerm && isOnSportsBook) {
    setSearchType(SEARCH_TYPE.SPORT);
    setSearchText(searchTerm);
    return;
  }

  if (searchTerm && isOnCasino) {
    setSearchType(SEARCH_TYPE.CASINO);
    setSearchText(searchTerm);
    return;
  }

  const search = window.location.search;
  const accessingSearchViaDeeplinkWithoutText = search.includes(`${SEARCH_PARAM_KEY.SEARCH_TERM}=`) && !searchTerm;
  if (accessingSearchViaDeeplinkWithoutText) {
    browserHistory.replace(path);
  }
};

export const openSearch = () => {
  addSearchParamToURL(SEARCH_PARAM_KEY.SEARCH_TERM, '');
  if (browserHistory.location.pathname.includes(PATHS.APP.CASINO.ROOT)) {
    setSearchType(SEARCH_TYPE.CASINO);
  } else {
    setSearchType(SEARCH_TYPE.SPORT);
  }
};
